import useSWR from 'swr'
import { getReq } from '../service/API'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useGroup = (projectId: string, groupId: string) => {
  const p = groupId ? ENDPOINTS.GROUPS.get(projectId, groupId) : ''
  const { data, mutate, error } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
